module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "LOP"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("List of Plates")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T-34 tanks on the production line.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vyacheslav Malyshev was the Soviet engineer tasked by Stalin with running the Soviet Union’s tank industry.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lend-Lease Matilda tank with a tank unit in the Central Front, January 1943.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Su-122 self-propelled gun negotiates its way down a very muddy trail.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German preparations for Operation Zitadelle were extensive.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Soviet tank company commander briefs his platoon leaders on their next operation.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The turret of a Panther Ausf D after an internal explosion had shattered the interior.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A German StuG-III assault gun pauses by a burning T-34/76 Model 1942 in the summer of 1943.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This is the same burning T-34 as in the previous photo.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Tiger positioned next to a knocked-out KV-1.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crewmen of a Panther loading 7.5-cm ammunition in a hurried, haphazard manner which begs for an accident.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T-34 with its turret blown off after a massive explosion.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The crew of an SU-76M assault gun in action.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soviet T-34s enroute to Zhitomir, November 1943.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Soviet KV-85 tank captured during the German counter-attack near Radomyschyl in early December 1943.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soviet Lend Lease Churchill tanks entering Kiev, November 1943.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T-34s advance with infantry across a frozen field, winter 1943/44.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A German Pz IV advancing with an infantry section.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The recapture of Zhitomir in late November 1943 was a minor tactical victory, but von Manstein’s armored counter-offensive failed to destroy Rybalko’s 3 GTA or recover Kiev.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Kampfgruppe from 1.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German infantry ride atop a Pz IV tank during the winter of 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A German grenadier with a Panzerfaust observes a burning T-34 in a village.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A late-model Pz IV alongside a knocked-out late-model T-34/76 in the Ukraine, early 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Panther from SS-"), _c('i', [_vm._v("Wiking")]), _vm._v(" in a wood line in Poland, September 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lend-lease Sherman in Red Army service.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A JS-2 lies disabled in the streets of an East Prussian town.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Plates#plt27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another JS-2 has come to grief in a German city street, which was far too narrow for armoured operations.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036cb83e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_ListOfPlates.vue
// module id = 66
// module chunks = 0